import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { DatePipe } from '@angular/common';
import { QuestionarioRoutingModule } from './questionario-routing.module';
import { QuestionarioAvaliacaoComponent } from './bloco-avaliacao/questionario-avaliacao.component';
import { QuestionarioComplementarComponent } from './bloco-complementar/questionario-complementar.component';
import { QuestionarioMainComponent } from './questionario-main.component';
import { QuestionarioRevisaoComponent } from './bloco-revisao/questionario-revisao.component';
import { QuestionarioMenuComponent } from './questionario-menu.component';
import { BnStepperComponent } from '@bndes/bndes-ux4/bn-stepper';
import { QuestionarioQualificacaoComponent } from './qualificacao/questionario-qualificacao.component';
import { QuestionarioRecomendacoesAoClienteComponent } from './bloco-recomendacoes-ao-cliente/questionario-recomendacoes-ao-cliente.component';

@NgModule({
  imports: [
	  SharedModule,
    QuestionarioRoutingModule,
    BnStepperComponent
  ],
  declarations: [
    QuestionarioMainComponent,
    //QuestionarioAvaliacaoComponent,
    QuestionarioQualificacaoComponent,
    QuestionarioComplementarComponent,
    QuestionarioRecomendacoesAoClienteComponent,
    QuestionarioRevisaoComponent,
    QuestionarioMenuComponent,
  ],
  providers: [
    DatePipe
  ]
})
export class QuestionarioModule { }
